module.exports = __webpack_public_path__ + "static/media/outlet.e8f8ccde.svg";